import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e95ebae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-links" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "close-button" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bar bar-to-right" }),
  /*#__PURE__*/_createElementVNode("span", { class: "bar bar-to-left" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["data-aos"]

import NavigationLinksLink from '@/components/Navbar/NavigationLinksLink.vue';
import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { useThemeStore } from '@/stores/theme';
import { useNavMenuStore } from '@/stores/navMenu';
import { ref } from '@vue/reactivity';
import { AlignmentType } from '@/types/AlignmentType';
import { DarkTheme, HorizontalNavigationAlignment, LightTheme, VerticalNavigationAlignment } from '@/constants/app';

type LinksAnimationType = 'zoom-in-up' | null;

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationLinks',
  props: {
    alignment: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useLanguageSwitcher();

const themeStore = useThemeStore();

const navMenuStore = useNavMenuStore();



// animation only for menu on big screens
const linksAnimation = ref<LinksAnimationType>(props.alignment === 'horizontal' ? 'zoom-in-up' : null);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.alignment === _unref(VerticalNavigationAlignment))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{ 'hidden': !_unref(navMenuStore).opened }, "area-to-close-menu"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(navMenuStore).close();})
        }, _hoisted_3, 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", { "data-aos": _unref(linksAnimation) }, [
      _createElementVNode("nav", {
        class: _normalizeClass({ 'vertical': props.alignment === _unref(VerticalNavigationAlignment),
                          'horizontal': props.alignment === _unref(HorizontalNavigationAlignment),
                          'hidden-text': (props.alignment === _unref(VerticalNavigationAlignment) && !_unref(navMenuStore).opened) })
      }, [
        _createVNode(NavigationLinksLink, {
          element: "achievements",
          text: "achievements",
          alignment: props.alignment
        }, null, 8, ["alignment"]),
        _createVNode(NavigationLinksLink, {
          element: "experience",
          text: "experience",
          alignment: props.alignment
        }, null, 8, ["alignment"]),
        _createVNode(NavigationLinksLink, {
          element: "clientwork",
          text: "client work",
          alignment: props.alignment
        }, null, 8, ["alignment"]),
        _createVNode(NavigationLinksLink, {
          element: "favorites",
          text: "favorites",
          alignment: props.alignment
        }, null, 8, ["alignment"]),
        _createVNode(NavigationLinksLink, {
          element: "contact",
          text: "contact",
          alignment: props.alignment
        }, null, 8, ["alignment"])
      ], 2)
    ], 8, _hoisted_4),
    _createElementVNode("div", {
      class: _normalizeClass(["area-below-to-close-menu", { 'hidden': !_unref(navMenuStore).opened }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(navMenuStore).close();})
    }, null, 2)
  ]))
}
}

})